import {useBasicAuth} from "../util/BasicAuth";
import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  ThemeProvider
} from "@mui/material";
import axios from "axios";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../store";
import {setErrorMessage} from "../store/reducers/message";
import {loginTheme} from "../style/login-theme";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export const BasicLogin = () => {
  const auth = useBasicAuth();
  const [user, setUser] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const onClickShowPassword = () => setShowPassword(!showPassword);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let axiosConfig = {auth: {username: user, password: password}, headers: {"Content-Type": "application/json"}};
    try {
      const loginUrl = process.env.REACT_APP_COVCHILD_CONTROL_URL + "/admin/login"
      await axios.get(loginUrl, axiosConfig);
      auth?.login(user, password);
      navigate(location?.state?.from?.pathname || "/");
    } catch (error: any) {
      if (error.response?.status === 401) {
        dispatch(setErrorMessage("Die Login Credentials sind nicht gültig."));
      } else {
        dispatch(setErrorMessage("Der Login hat nicht funktioniert. Bitte versuchen Sie es später erneut."));
      }
    }
  }

  return (
    <ThemeProvider theme={loginTheme}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Paper sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 4, width: 500}}>
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <TextField
              id="username" label="Benutzername" name="username" autoFocus
              onChange={e => setUser(e.target.value)}
            />
            <TextField
              id="password" label="Kennwort" name="password" type={showPassword ? "text" : "password"}
              onChange={e => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                        aria-label="toggle password visibility" onClick={onClickShowPassword}
                        onMouseDown={onClickShowPassword}
                    >
                      {showPassword ? <Visibility/> : <VisibilityOff/>}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Button type="submit" disabled={user.length === 0 || password.length === 0}>
              Anmelden
            </Button>
          </Box>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}